import React, { useState } from 'react';
import { X } from 'lucide-react';
import { organizersAPI } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

export default function ContactOrganizerModal({ organizerId, organizerName, eventId, onClose }) {
  const { user } = useAuth();
  const [name, setName] = useState(user?.name || '');
  const [email, setEmail] = useState(user?.email || '');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setSending(true);
    setError('');
    try {
      await organizersAPI.contact(organizerId, { name, email, message, event_id: eventId });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to send message. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div
        className="bg-[#0A0A0A] border border-gray-800 rounded-xl p-6 w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
        data-testid="contact-organizer-modal"
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-black uppercase text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Contact {organizerName}
          </h3>
          <button onClick={onClose} className="text-gray-500 hover:text-white">
            <X size={20} />
          </button>
        </div>

        {sent ? (
          <div className="text-center py-8">
            <p className="text-green-400 font-semibold mb-2">Message sent!</p>
            <p className="text-gray-400 text-sm">{organizerName} will get back to you soon.</p>
            <button onClick={onClose} className="btn-primary text-sm px-4 py-2 rounded mt-6">Close</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-3">
            {!user && (
              <>
                <input
                  type="text"
                  placeholder="Your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="w-full bg-black/60 border border-gray-700 text-white px-3 py-2.5 rounded text-sm focus:border-red-500"
                  data-testid="contact-name-input"
                />
                <input
                  type="email"
                  placeholder="Your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full bg-black/60 border border-gray-700 text-white px-3 py-2.5 rounded text-sm focus:border-red-500"
                  data-testid="contact-email-input"
                />
              </>
            )}
            <textarea
              placeholder="Your message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              rows={4}
              className="w-full bg-black/60 border border-gray-700 text-white px-3 py-2.5 rounded text-sm focus:border-red-500 resize-none"
              data-testid="contact-message-input"
            />
            {error && <p className="text-red-400 text-xs">{error}</p>}
            <button
              type="submit"
              disabled={sending}
              className="w-full btn-primary py-2.5 rounded text-sm font-bold disabled:opacity-50"
              data-testid="contact-send-btn"
            >
              {sending ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
